import React, { Component } from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from '../../utils/RecordsPagination';

// material ui icons
import EditIcon from "@material-ui/icons/Edit";

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    TableFooter
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
import Tooltip from '@material-ui/core/Tooltip';
import ViewIcon from "@material-ui/icons/RemoveRedEye";
// import AllDataEntryTable from "./Index";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    input: {
        marginTop: "0 !important"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "67%"
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px",
        width: '100%'
    },
    icon: {
        margin: "8px 0px 8px 0px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    }
});

const CustomTableCell = withStyles(theme => ({
    head: {
        color: " #66bb6a",
        fontSize: "14px",
        fontWeight: "lighter"
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

function DataEntryTableStructure(props) {
    const { classes, myDataEntryData, filterAirlines,
        filterStatus, openEditModal, openViewMore, pageIndex } = props;


    return (

        <div>
            <div className={classes.tableResponsive}
                 style={{ overflowX: "auto" }}>
                <Table className={classes.table} aria-labelledby="tableTitle">
                    <TableHead className={classes.negativeColor} color="primary">
                        <TableRow>
                            <CustomTableCell>S/No</CustomTableCell>
                            <CustomTableCell >Airline <br /> Name</CustomTableCell>
                            <CustomTableCell >Flight Number</CustomTableCell>
                            <CustomTableCell >Departure <br /> Date </CustomTableCell>
                            <CustomTableCell >Departure <br /> Location </CustomTableCell>
                            <CustomTableCell >Destination <br /> Location</CustomTableCell>
                            {/*<CustomTableCell >Passenger <br /> Count</CustomTableCell>*/}
                            {/*<CustomTableCell >Billable <br /> Passenger <br /> Count</CustomTableCell>*/}
                            {/*<CustomTableCell >Created <br /> Date</CustomTableCell>*/}
                            <CustomTableCell >Status</CustomTableCell>
                            {/*<CustomTableCell >Comments</CustomTableCell>*/}
                            <CustomTableCell >Actions</CustomTableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {myDataEntryData.map((item, key) => {
                            return (
                                <TableRow hover key={key}>
                                     <TableCell >{pageIndex + key}</TableCell>
                                    <TableCell >{filterAirlines(item.AirlineId)}</TableCell>
                                    <TableCell >{item.FlightNo}</TableCell>
                                    <TableCell >{(item.DepartureDate) ? appHelpers.formatDate(item.DepartureDate, "MMM DD, YYYY") : ""}</TableCell>
                                    <TableCell >{item.DepartureLocation}</TableCell>
                                    <TableCell >{item.DestinationLocation}</TableCell>
                                    {/*<TableCell >{appHelpers.numberWithCommasOnly(item.PassengerCount)}</TableCell>*/}
                                    {/*<TableCell >{appHelpers.numberWithCommasOnly(item.BillablePassenger)}</TableCell>*/}
                                    {/*<TableCell >{(item.DateSubmitted) ? appHelpers.formatDate(item.DateSubmitted, "MMM DD, YYYY") : ""}</TableCell>*/}
                                    <TableCell >{filterStatus(item.Status)}</TableCell>
                                    {/*<TableCell >{(item.Comments ? item.Comments : "")}</TableCell>*/}
                                    <TableCell>
                                    {item.Status === 0
                                    &&
                                         <span>
                                                 <span style={{ cursor: "pointer" }} onClick={() => openViewMore(item)}>
                                                     <Tooltip title="View" placement="top">
                                                             <span className={classes.icon}><ViewIcon /></span>
                                                         </Tooltip>
                                                 </span>
                                            <span
                                                onClick={() => openEditModal(item)}
                                                style={{ cursor: "pointer", color: "#ff9800", padding: "0 5px", float: "left" }}
                                            >
                                              <span className={classes.icon}>
                                                <EditIcon />
                                              </span>
                                              Edit
                                            </span>
                                         </span>
                                    }
                                    {item.Status === 1
                                    &&
                                        <span>
                                             <span style={{ cursor: "pointer" }} onClick={() => openViewMore(item)}>
                                                 <Tooltip title="View" placement="top">
                                                         <span className={classes.icon}><ViewIcon /></span>
                                                 </Tooltip>
                                             </span>
                                            <span
                                                style={{
                                                    cursor: "pointer", backgroundColor: "#43a047",
                                                    borderRadius: "5px", padding: "5px 10px", color: "#ffffff"
                                                }}
                                            >
                                            Approved
                                            </span>
                                        </span>
                                    }
                                    {item.Status === 2
                                    &&
                                        <span>
                                             <span style={{ cursor: "pointer" }} onClick={() => openViewMore(item)}>
                                                 <Tooltip title="View" placement="top">
                                                         <span className={classes.icon}><ViewIcon /></span>
                                                 </Tooltip>
                                             </span>
                                            <span
                                                style={{
                                                    cursor: "pointer", backgroundColor: "#dd2735",
                                                    borderRadius: "5px", padding: "5px 10px", color: "#ffffff"
                                                }}
                                            >
                                              Declined
                                            </span>
                                        </span>
                                    }
                                </TableCell>

                                </TableRow>
                            );
                        })}
                    </TableBody>
                <TableFooter>
                </TableFooter>
            </Table>

            </div >
        </div >
    );
}

class myDataEntryTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { classes, fetchDataEntry, totalCount, pageSize, currentPage, filterAirlines,
            filterStatus, openEditModal, myDataEntryData,  openViewMore} = this.props;
        const pageIndex = (pageSize * (currentPage - 1)) + 1;
        return (
            <div>

                <RecordPagination
                    fetchMore={fetchDataEntry}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    target={<DataEntryTableStructure
                        pageIndex={pageIndex}
                        classes={classes}
                        myDataEntryData={myDataEntryData}
                        filterAirlines={filterAirlines}
                        filterStatus={filterStatus}
                        openEditModal={openEditModal}
                        openViewMore={openViewMore}

                    />}
                />
            </div>
        );
    }
}

export default (withMobileDialog()(withStyles(styles)(myDataEntryTable)));



// WEBPACK FOOTER //
// ./src/views/DataEntry/MyDataEntryTable.jsx